import { render, staticRenderFns } from "./PaymentsFilters.yaml?vue&type=template&id=1b1dbb79&component"
import script from "./PaymentsFilters.yaml?vue&type=script&lang=ts&component"
export * from "./PaymentsFilters.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports